import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import ConfirmActionDialog from "../../../components/ConfirmActionDialog";
import { deleteVisitor } from "../../../axios/Visitor/VisitorApi";

const DeleteVisitorUserDialog = ({ open, onClose, onRefresh, id }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    if (loading) return;
    onClose?.();
  };

  const handleSubmit = async () => {
    if (!id) {
      toast.warn(t("common.select-a-row-first"));
      return;
    }

    setLoading(true);
    try {
      const payload = {
        langId: localStorage.getItem("i18nextLngId"),
        id,
      };
      const response = await deleteVisitor(payload);

      if (response?.status === 200) {
        toast.success(t("common.delete-visitor-user-successfully"));
        onRefresh?.();
        onClose?.();
      } else {
        toast.error(response?.data?.message || t("common.error"));
      }
    } catch (err) {
      toast.error(
        err?.response?.data?.message || t("common.network-or-server-error")
      );
      console.error("Delete visitor user error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ConfirmActionDialog
      open={open}
      variant="delete"
      title={t("common.delete-visitor-user")}
      subtitle={t("common.are-you-sure-delete-this-visitor-user")}
      confirmText={t("button.delete")}
      loading={loading}
      onClose={handleClose}
      onConfirm={handleSubmit}
    />
  );
};

export default DeleteVisitorUserDialog;
